/** Keeps `format.ts`'s absolute-date time zone in sync with the active
 * organisation's `timezone` (from `/auth/me`). Rendered once, high in the
 * tree, so every page's `formatDate`/`formatDateTime`/`formatTime` renders
 * in the org tz — not the browser tz. On public pages (no auth) `me` is
 * empty → the tz stays undefined → browser tz, which is the right default
 * for a beneficiary. */
import { useEffect } from "react";

import { useMe } from "@/lib/auth";
import { setDisplayTimeZone } from "@/lib/format";

export function DisplayTimeZoneSync() {
  const me = useMe();
  const tz = me.data?.active_org?.timezone;
  useEffect(() => {
    setDisplayTimeZone(tz);
  }, [tz]);
  return null;
}
